import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User, UserSecret } from './user.model';
import { AppService } from '../../app.service';
import 'rxjs/add/operator/map'

@Injectable()
export class UserService {
    private serviceURI = 'account/r/';
    constructor(private apiservice: AppService) {
    }
    getUser(): Observable<User[]> {
        return this.apiservice.get(`${this.serviceURI}`);
    }

    createUser(user: UserSecret): Observable<any> {
        return this.apiservice.post(`${this.serviceURI}`, user);
    }

    updateUser(userId: number, user: User): Observable<number> {
        return this.apiservice.put(`${this.serviceURI}`, userId, user);
    }

    deleteUser(userId: number): Observable<number> {
        return this.apiservice.delete(`${this.serviceURI}`, userId);
    }

}





// WEBPACK FOOTER //
// ./src/app/home-page/user/user.service.ts